const $ = jQuery.noConflict();

'use strict';
const ChangeLayout = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		if ($(window).width() <= 819) {
			this.moveElement();
		}
	},

	moveElement: function() {
		$('.image-info-list__list-image').appendTo('.image-info-list-holder');
	},
};

export default ChangeLayout;
